import { AccountSearch, AccountSearchSchema } from "@models/account";
import { createBrowseUrlParams, DEFAULT_SORT_KEY, DEFAULT_SORT_METHOD, ParsedBrowseUrl } from "./browseUrlParams";

export { DEFAULT_SORT_KEY, DEFAULT_SORT_METHOD };
export type ParsedAccountBrowseUrl = ParsedBrowseUrl<AccountSearch>;

const accountBrowseUrl = createBrowseUrlParams<AccountSearch>(AccountSearchSchema, {
  omitFromUrl: ["account_type"],
});

export const parseAccountBrowseUrlParams = accountBrowseUrl.parseBrowseUrlParams;
export const syncAccountBrowseUrlParams = accountBrowseUrl.syncBrowseUrlParams;
